import { useState } from "react";
import { Button } from "./components/Button";
import { MemoInput } from "./components/MemoInput";
import { MemoList } from "./components/MemoList";
import { RandomResult } from "./components/RandomResult";
import "./styles.css";

export const RandomTool = () => {
  // 入力フォームの値を管理
  const [text, setText] = useState("");

  // メモ一覧を配列で管理
  const [memos, setMemos] = useState([]);

  // ランダムで表示する結果を管理
  const [result, setResult] = useState("");

  // 追加ボタン押下時の処理
  const onClickAdd = () => {
    // 空文字は追加しない（バリデーション）
    if (text === "") return;

    // IDを付与することで削除時に識別できるようにする
    const newMemo = {
      text,
      id: crypto.randomUUID(),
    };

    // 既存配列をコピーして新しいメモを追加
    setMemos([...memos, newMemo]);

    // 入力欄をリセット
    setText("");
  };

  // 削除
  const onClickDelete = (id) => {
    // filterを使って指定ID以外を残す
    const newMemos = memos.filter((memo) => memo.id !== id);

    // 新しい配列でstate更新
    setMemos(newMemos);
  };

  // ランダム抽選処理
  const onClickRandom = () => {
    // メモが存在しない場合は何もしない
    if (memos.length === 0) return;

    // 配列の長さをもとにランダムなインデックスを生成
    const randomIndex = Math.floor(Math.random() * memos.length);

    // 該当するメモを結果として設定
    setResult(memos[randomIndex].text);
  };

  return (
    <>
      <h2 className="title">RandomTool</h2>
      <p className="title">今晩のおかずに迷ったときのための運任せツール</p>

      {/* 入力コンポーネント：値とイベントをpropsで渡す */}
      <MemoInput
        text={text}
        onChange={(e) => setText(e.target.value)}
        onClick={onClickAdd}
      />

      {/* メモ一覧表示 */}
      <MemoList memos={memos} onDelete={onClickDelete} />

      {/* 抽選ボタン */}
      <Button className="result-button" onClick={onClickRandom}>
        抽選する
      </Button>

      {/* 結果表示コンポーネント */}
      <RandomResult result={result} />
    </>
  );
};

export default RandomTool;